let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2Q3RU")).then(() => parcelRequire('czWl2'));